//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions, mapGetters } from 'vuex';
import constants from '~/constants';
import BannerSwiper from '~/components/BannerSwiper';
import CategoryList from '~/components/CategoryList';
import Loading from '~/components/Loading';

export default {
  name: 'News',

  components: {
    BannerSwiper,
    CategoryList,
    Loading,
  },

  data() {
    return {
      CDN: process.env.CDN,
      page: 1,
      activeCategory: 0,
      initialSlide: 0, // for CategoryList initialSlide
    };
  },

  computed: {
    ...mapState(['news', 'isLoading']),
    ...mapGetters(['newsCategoryName']),
    categories() {
      if (!this.news) return [];
      const categories = [
        {
          id: 0,
          name: this.$i18n.t('NEWS__CATEGORY__0'),
        },
        ...this.news.categories,
      ];
      return categories;
    },
    queryCategory() {
      return Number(this.$route.query.active);
    },
  },

  watch: {
    queryCategory: {
      handler(val) {
        if (val >= 0) {
          this.activeCategory = val;
          this.$router.replace({ query: null });
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions(['getNews']),
    async handleCategoryClick(categoryId, initialSlide) {
      const news = await this.getNews({
        category: categoryId,
        withTop: constants.WITHOUT_TOP,
      });

      if (news) {
        this.activeCategory = categoryId;
        this.initialSlide = initialSlide;
      }
    },
    async handlePaginateClick() {
      await this.getNews({
        category: this.activeCategory,
        page: this.page,
        withTop: constants.WITHOUT_TOP,
      });
    },
  },

  async validate({ store, query }) {
    const queryVerification = query.active ? Number(query.active) : true;
    let news = null;

    if (queryVerification || queryVerification >= 0) {
      const payload =
        queryVerification >= 0 ? { category: queryVerification } : {};

      news = await store.dispatch('getNews', {
        payload,
      });
    }

    return (queryVerification || queryVerification >= 0) && !!news;
  },
};
